import dayjs from 'dayjs';

export const DATAGRIDPRO_DEFAULTS = {
  rowSelection: false,
  checkboxSelection: false,
  disableRowSelectionOnClick: true,
  disableColumnSelector: true,
  disableMultipleRowSelection: true,
  disableColumnMenu: true,
  disableColumnReorder: true,
  disableColumnResize: true,
  disableVirtualization: false,
  hideFooter: true,
  sx: {
    '& .MuiDataGrid-cell:focus': {
      outline: 'none'
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none'
    }
  }
};

export const DATE_VALUE_GETTER = (value: string | number, useUtcTime: boolean, use24HourFormat: boolean) => {
  if (!value) return '';

  const date = dayjs.utc(value);
  const displayDate = useUtcTime ? date : date.local();
  const timeFormat = use24HourFormat ? 'HH:mm' : 'hh:mm A';

  return displayDate.format(`YYYY-MM-DD ${timeFormat} Z`);
};
